import { LabelType, LabelGroup, } from '@wix/ambassador-inbox-labels-server/types';
export function isAssigneeLabel(label) {
    return (label.group === LabelGroup.ASSIGNEE && label.type === LabelType.USER_ID);
}
var findLabelById = function (labelId, labelsList) {
    return labelsList.find(function (label) { return label.id === labelId; });
};
export var getAssigneesLabel = function (labelIds, labelsList) {
    if (labelIds === void 0) { labelIds = []; }
    if (labelsList === void 0) { labelsList = []; }
    return labelIds
        .map(function (labelId) { return findLabelById(labelId, labelsList); })
        .filter(Boolean)
        .filter(isAssigneeLabel); //should only have one.
};
export var SYSTEM_LABELS_IDS;
(function (SYSTEM_LABELS_IDS) {
    SYSTEM_LABELS_IDS["UNASSIGNED"] = "10e089f2-1c4f-4db4-b1c4-b8ce552d120f";
    SYSTEM_LABELS_IDS["ERROR"] = "6713d2ca-8b15-11eb-8dcd-0242ac130003";
    SYSTEM_LABELS_IDS["STAR"] = "7553d8c6-0ba2-424e-8e81-d1f7ea14bfe4";
})(SYSTEM_LABELS_IDS || (SYSTEM_LABELS_IDS = {}));
//# sourceMappingURL=labels.js.map